module.exports = __webpack_public_path__ + "img/entreGOALS-color.c51e4338.png";